import config from 'services/config'

export const getImgUrlFromCDN = (fileName, mediaTag, hotelId) => {
  const mediaTagRegex = new RegExp(`^c/|a/`)
  const cleanFileName = fileName.replace(mediaTagRegex, '')

  return `${config.inviteMediaBaseUrl}/${hotelId}/${mediaTag}/${cleanFileName}`
}

export const isCampaignImageVisible = mediaUrl => {
  const extension = getExtensionFromUrl(mediaUrl)
  return extension !== 'pdf'
}

export const getExtensionFromUrl = url => {
  if (!url) {
    return ''
  }

  const withoutQuery = url.split('?')[0].split('#')[0]
  const match = withoutQuery.match(/\.(\w+)$/i)

  return match ? match[1].toLowerCase() : ''
}
